module.exports = __webpack_public_path__ + "assets/fonts/iconfont.823782e6.ttf";